import CustomersTableModule from './CustomersTable.module';

export * from './CustomersTableModuleProps';
export default CustomersTableModule;
